<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9.40487,11.7463C8.96778,11.9103,8.49437,12,8,12C7.50563,12,7.03222,11.9103,6.59513,11.7463C6.59513,11.7463,5.89269,13.6195,5.89269,13.6195C6.54832,13.8655,7.25845,14,8,14C8.74155,14,9.45168,13.8655,10.1073,13.6195C10.1073,13.6195,9.40487,11.7463,9.40487,11.7463C9.40487,11.7463,9.40487,11.7463,9.40487,11.7463ZM11.7463,9.40487C11.7463,9.40487,13.6195,10.1073,13.6195,10.1073C13.8655,9.45168,14,8.74155,14,8C14,7.25845,13.8655,6.54832,13.6195,5.89269C13.6195,5.89269,11.7463,6.59513,11.7463,6.59513C11.9103,7.03222,12,7.50563,12,8C12,8.49437,11.9103,8.96778,11.7463,9.40487C11.7463,9.40487,11.7463,9.40487,11.7463,9.40487ZM9.40487,4.25367C9.40487,4.25367,10.1073,2.3805,10.1073,2.3805C9.45168,2.13453,8.74155,2,8,2C7.25845,2,6.54832,2.13453,5.89269,2.3805C5.89269,2.3805,6.59513,4.25367,6.59513,4.25367C7.03222,4.08968,7.50563,4,8,4C8.49437,4,8.96778,4.08968,9.40487,4.25367C9.40487,4.25367,9.40487,4.25367,9.40487,4.25367ZM4.25367,6.59513C4.25367,6.59513,2.3805,5.89269,2.3805,5.89269C2.13453,6.54832,2,7.25845,2,8C2,8.74155,2.13453,9.45168,2.3805,10.1073C2.3805,10.1073,4.25367,9.40487,4.25367,9.40487C4.08968,8.96778,4,8.49437,4,8C4,7.50563,4.08968,7.03222,4.25367,6.59513C4.25367,6.59513,4.25367,6.59513,4.25367,6.59513ZM8,16C3.58172,16,0,12.4183,0,8C0,3.58172,3.58172,0,8,0C12.4183,0,16,3.58172,16,8C16,12.4183,12.4183,16,8,16C8,16,8,16,8,16ZM8,10C9.10457,10,10,9.10457,10,8C10,6.89543,9.10457,6,8,6C6.89543,6,6,6.89543,6,8C6,9.10457,6.89543,10,8,10C8,10,8,10,8,10Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Lifesaver',
} as DefineComponent
</script>
